module.exports = __webpack_public_path__ + "static/media/chart.b8e4de81.jpg";